module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_vm._v("\n        เป็น Atomic Class ที่ใช้จัดการ Style ที่เกี่ยวกับ Background ประกอบด้วย\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-background-color"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้กำหนดสีของ Background ให้กับ Element\n      ")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-background-size"
    }
  }), _vm._v(" "), _vm._m(23), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้กำหนดรูปแบบการ Fill ของ Background Image\n      ")]), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-background-repeat"
    }
  }), _vm._v(" "), _vm._m(34), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้กำหนดรูปแบบการ Repeat ของ Background Image\n      ")]), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _c('div', {
    staticClass: "anchor",
    attrs: {
      "id": "atomic-background-position"
    }
  }), _vm._v(" "), _vm._m(45), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        ใช้กำหนดตำแหน่งการจัดวางของ Background\n      ")]), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicAlignment'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("   Alignment\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'AtomicBorder'
      }
    }
  }, [_vm._v("\n            Border   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-border"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Background\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-128px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-background-color"
    }
  }, [_vm._v("Background Color")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-background-size"
    }
  }, [_vm._v("Background Size")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-background-repeat"
    }
  }, [_vm._v("Background Repeat")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#atomic-background-position"
    }
  }, [_vm._v("Background Position")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-background-color"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Background Color\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bgcl-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("background-color")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bgcl-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Biomatic's Color Name Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("primary[-{100-900}]")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("accent[-{100-900}]")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("neutral[-{100-900}]")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("positive")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("negative")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("warning")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("white")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("gray")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("dark")]), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("black")])]), _vm._v(" "), _c('p')])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-hover")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Background Color – Branding Color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Primary Color -->\n<div>\n  <div class=\"_bgcl-primary\">primary</div>\n  <div class=\"_bgcl-primary-100\">primary-100</div>\n  <div class=\"_bgcl-primary-200\">primary-200</div>\n  <div class=\"_bgcl-primary-300\">primary-300</div>\n  <div class=\"_bgcl-primary-400\">primary-400</div>\n  <div class=\"_bgcl-primary-500\">primary-500</div>\n  <div class=\"_bgcl-primary-600\">primary-600</div>\n  <div class=\"_bgcl-primary-700\">primary-700</div>\n  <div class=\"_bgcl-primary-800\">primary-800</div>\n  <div class=\"_bgcl-primary-900\">primary-900</div>\n</div>\n\n<!-- Accent Color -->\n<div>\n  <div class=\"_bgcl-accent\">accent</div>\n  <div class=\"_bgcl-accent-100\">accent-100</div>\n  <div class=\"_bgcl-accent-200\">accent-200</div>\n  <div class=\"_bgcl-accent-300\">accent-300</div>\n  <div class=\"_bgcl-accent-400\">accent-400</div>\n  <div class=\"_bgcl-accent-500\">accent-500</div>\n  <div class=\"_bgcl-accent-600\">accent-600</div>\n  <div class=\"_bgcl-accent-700\">accent-700</div>\n  <div class=\"_bgcl-accent-800\">accent-800</div>\n  <div class=\"_bgcl-accent-900\">accent-900</div>\n</div>\n\n<!-- Neutral Color -->\n<div>\n  <div class=\"_bgcl-neutral\">neutral</div>\n  <div class=\"_bgcl-neutral-100\">neutral-100</div>\n  <div class=\"_bgcl-neutral-200\">neutral-200</div>\n  <div class=\"_bgcl-neutral-300\">neutral-300</div>\n  <div class=\"_bgcl-neutral-400\">neutral-400</div>\n  <div class=\"_bgcl-neutral-500\">neutral-500</div>\n  <div class=\"_bgcl-neutral-600\">neutral-600</div>\n  <div class=\"_bgcl-neutral-700\">neutral-700</div>\n  <div class=\"_bgcl-neutral-800\">neutral-800</div>\n  <div class=\"_bgcl-neutral-900\">neutral-900</div>\n</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "lo-12 lo-4-sm -gap-16px"
  }, [_c('div', [_c('div', {
    staticClass: "_bgcl-primary _cl-white _h-128px _bdtrrd-3px _bdtlrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("primary")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-100 _cl-neutral-800 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-100")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-200 _cl-neutral-800 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-200")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-300 _cl-neutral-900 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-300")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-400 _cl-neutral-900 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-400")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-500 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-500")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-600 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-600")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-700 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-700")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-800 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-800")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-primary-900 _cl-white _pd-12px _bdbtrrd-3px _bdbtlrd-3px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("primary-900")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "_bgcl-accent _cl-white _h-128px _bdtrrd-3px _bdtlrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("accent")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-100 _cl-neutral-800 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-100")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-200 _cl-neutral-800 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-200")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-300 _cl-neutral-900 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-300")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-400 _cl-neutral-900 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-400")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-500 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-500")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-600 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-600")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-700 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-700")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-800 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-800")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-accent-900 _cl-white _pd-12px _bdbtrrd-3px _bdbtlrd-3px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("accent-900")])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "_bgcl-neutral _cl-white _h-128px _bdtrrd-3px _bdtlrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("neutral")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-100 _cl-neutral-800 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-100")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-200 _cl-neutral-800 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-200")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _cl-neutral-900 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-300")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-400 _cl-neutral-900 _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-400")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-500 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-500")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-600 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-600")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-700 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-700")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-800 _cl-white _pd-12px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-800")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-900 _cl-white _pd-12px _bdbtrrd-3px _bdbtlrd-3px _dp-f _alit-fe"
  }, [_c('strong', [_vm._v("neutral-900")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Background Color – Semantic Color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Semantic Color -->\n<div class=\"_bgcl-positive\">positive</div>\n<div class=\"_bgcl-negative\">negative</div>\n<div class=\"_bgcl-warning\">warning</div>\n<div class=\"_bgcl-info\">info</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "lo-12 lo-4-sm -gap-16px"
  }, [_c('div', {
    staticClass: "_bgcl-positive _cl-white _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("positive")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-negative _cl-white _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("negative")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-warning _cl-white _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("warning")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-info _cl-white _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("info")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Background Color – Grayscale Color")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<!-- Grayscale Color -->\n<div class=\"_bgcl-positive\">positive</div>\n<div class=\"_bgcl-negative\">negative</div>\n<div class=\"_bgcl-warning\">warning</div>\n<div class=\"_bgcl-info\">info</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('div', {
    staticClass: "lo-12 lo-4-sm -gap-16px"
  }, [_c('div', {
    staticClass: "_bgcl-white _cl-neutral-700 _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("white")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-gray _cl-neutral-700 _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("gray")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-dark _cl-white _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("dark")])]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-black _cl-white _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("black")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Background Color – Hover")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"_bgcl-positive _bgcl-negative-hover\">Hover Me</div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', {
    staticClass: "lo-12 lo-4-sm -gap-16px"
  }, [_c('div', {
    staticClass: "_bgcl-positive _bgcl-negative-hover _cl-white _h-128px _bdrd-3px _pd-12px _dp-f _alit-fe"
  }, [_c('strong', {
    staticClass: "_fs-4"
  }, [_vm._v("Hover Me")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-background-size"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Background Size\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bgs-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("background-size")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bgs-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("cv")]), _vm._v(" สำหรับ \"cover\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("ct")]), _vm._v(" สำหรับ \"contain\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Background Size")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"\"></div>\n<div class=\"_bgs-ct\"></div>\n<div class=\"_bgs-cv\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', {
    staticClass: "_mgbt-32px"
  }, [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Original Image")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://placeimg.com/200/200/animals",
      "alt": "image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "lo-12 lo-4-sm -gap-16px"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Default")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Contain")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image _bgs-ct"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Cover")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image _bgs-cv"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-background-repeat"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Background Repeat\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bgrp-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("background-repeat")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bgrp-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("rp")]), _vm._v(" สำหรับ \"repeat\" "), _c('small', {
    staticClass: "_opct-50"
  }, [_vm._v("(default)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("rpx")]), _vm._v(" สำหรับ \"repeat-x\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("rpy")]), _vm._v(" สำหรับ \"repeat-y\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("nrp")]), _vm._v(" สำหรับ \"no-repeat\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("sp")]), _vm._v(" สำหรับ \"space\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("r")]), _vm._v(" สำหรับ \"round\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Background Repeat")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"_bgrp-rp\"></div>\n<div class=\"_bgrp-rpx\"></div>\n<div class=\"_bgrp-rpy\"></div>\n<div class=\"_bgrp-nrp\"></div>\n<div class=\"_bgrp-sp\"></div>\n<div class=\"_bgrp-r\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', {
    staticClass: "_mgbt-32px"
  }, [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Original Image")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "https://placeimg.com/40/40/animals",
      "alt": "image"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "lo-12 lo-4-sm -gap-16px"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Default/ Repeat")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Repeat X")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-rpx"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Repeat Y")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-rpy"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("No Repeat")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Space")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-sp"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Round")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-r"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-3 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#atomic-background-position"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Background Position\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Class Name")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bgpst-*")]), _vm._v(" สำหรับ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("background-position")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Value")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-32px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class Name")]), _vm._v(" "), _c('th', [_vm._v("Value")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("_bgpst-*")])])]), _vm._v(" "), _c('td', [_c('p', [_c('strong', [_vm._v("Keyword Value: ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("t")]), _vm._v(" สำหรับ \"top\" "), _c('small', {
    staticClass: "_opct-50"
  }, [_vm._v("(default)")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("tr")]), _vm._v(" สำหรับ \"top right\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("tl")]), _vm._v(" สำหรับ \"top left\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("bt")]), _vm._v(" สำหรับ \"bottom\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("btr")]), _vm._v(" สำหรับ \"bottom right\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("btl")]), _vm._v(" สำหรับ \"bottom left\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("ct")]), _vm._v(" สำหรับ \"center\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("ctr")]), _vm._v(" สำหรับ \"center right\" "), _c('br'), _vm._v(" "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("ctl")]), _vm._v(" สำหรับ \"center left\"\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-4px _fs-5"
  }, [_c('strong', [_vm._v("Responsive:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-positive"
  }, [_c('strong', [_vm._v("Yes")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-32px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-sm")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-md")])]), _vm._v(" "), _c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("*-lg")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_c('strong', [_vm._v("Hover:")]), _vm._v(" "), _c('span', {
    staticClass: "_cl-negative"
  }, [_c('strong', [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Background Repeat")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<div class=\"_bgpst-tl\"></div>\n<div class=\"_bgpst-t\"></div>\n<div class=\"_bgpst-tr\"></div>\n<div class=\"_bgpst-ctl\"></div>\n<div class=\"_bgpst-ct\"></div>\n<div class=\"_bgpst-ctr\"></div>\n<div class=\"_bgpst-btl\"></div>\n<div class=\"_bgpst-bt\"></div>\n<div class=\"_bgpst-btr\"></div>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-128px"
  }, [_c('div', {
    staticClass: "lo-12 lo-4-sm -gap-16px"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Top Left")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-tl"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Top")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-t"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Top Right")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-tr"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Center Left")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-ctl"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Center")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-ct"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Center Right")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-ctr"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Bottom Left")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-btl"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Bottom")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-bt"
  })]), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-8px"
  }, [_vm._v("Bottom Right")]), _vm._v(" "), _c('div', {
    staticClass: "_bgcl-neutral-300 _h-128px _bdrd-3px _pd-12px test-background-image-2 _bgrp-nrp _bgpst-btr"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0386a932","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/AtomicBackground.vue
// module id = 110
// module chunks = 0